import baseApi from '../../base.api'

export const onFetchRubricProgressQueryStarted = async (arg, { dispatch, queryFulfilled }) => {
    try {
        const { data: progressData } = await queryFulfilled
        if (!progressData?.length) return

        // Update the questions cache with the new progress data
        dispatch(
            baseApi.util.updateQueryData('fetchQuestions', { token: arg.token, versionId: arg.versionId }, draft => {
                if (!draft) return

                // Create a map of questionRubricId -> progress for quick lookup
                const progressMap = new Map(
                    progressData.map(p => [
                        p.id,
                        {
                            status: p.processing.status,
                            message: p.processing.message,
                            progress: p.processing.progress,
                        },
                    ]),
                )

                console.log(progressMap)
                console.log(progressData)

                // Update each question's questionRubrics with new progress
                draft.forEach(question => {
                    question.questionRubrics?.forEach(qr => {
                        console.log(qr.id)
                        const newProgress = progressMap.get(qr.id)
                        if (newProgress) {
                            qr.processing = newProgress
                        }
                    })
                })
            }),
        )
    } catch (error) {
        console.error('Error fetching rubric progress:', error)
    }
}
